jQuery(document).ready(function($) {

  /* REGISTER EFFECTS ------------------------------------------- */

  // FADE IN: Opacity 0 -> 1
  gsap.registerEffect({
    name: 'fadeIn',
    effect: (targets, config) => {
      return gsap.fromTo(
        targets,
        {
          opacity: 0
        },
        {
          scrollTrigger: {
            trigger: targets,
            start: 'top 95%'
          },
          opacity: 1,
          duration: 1,
          ease: 'power2.out'
        }
      )
    }
  });

  // SLIDE RIGHT: Slide-in from the right
  gsap.registerEffect({
    name: 'slideRight',
    effect: (targets, config) => {
      return gsap.fromTo(
        targets,
        {
          x: '-50px'
        },
        {
          scrollTrigger: {
            trigger: targets,
            start: 'top 95%'
          },
          x: 'auto',
          duration: 1,
          ease: 'power2.out'
        }
      )
    }
  });

  // SLIDE RIGHT: Slide-in from the right
  gsap.registerEffect({
    name: 'slideUp',
    effect: (targets, config) => {
      return gsap.fromTo(
        targets,
        {
          y: '50px'
        },
        {
          scrollTrigger: {
            trigger: targets,
            start: 'top 95%'
          },
          y: 'auto',
          duration: config.duration,
          ease: 'power2.out'
        }
      )
    },
    defaults: {
      duration: 1
    }
  });

  // STAGGER FADE: Each item in a set fades-in at a staggered rate
  gsap.registerEffect({
    name: 'staggerFade',
    effect: (targets, config) => {
      return gsap.fromTo(
        targets,
        {
          opacity: '0'
        },
        {
          scrollTrigger: {
            trigger: targets,
            start: 'top 90%'
          },
          delay: config.delay,
          opacity: '1',
          duration: config.duration,
          stagger: config.stagger,
          ease: 'power2.out'
        }
      )
    },
    defaults: {
      delay: 0,
      duration: 1,
      stagger: 0.3
    }
  });

  // STAGGER FADE SLIDE: Each item in a set fades-in at a staggered rate and slides in from right
  gsap.registerEffect({
    name: 'staggerFadeSlide',
    effect: (targets, config) => {
      return gsap.fromTo(
        targets,
        {
          left: '-30px',
          opacity: '0'
        },
        {
          scrollTrigger: {
            trigger: targets,
            start: 'top 90%'
          },
          left: 'auto',
          opacity: '1',
          duration: config.duration,
          stagger: config.stagger,
          ease: 'power2.out'
        }
      )
    },
    defaults: {
      duration: 1,
      stagger: 0.3
    }
  });


  /* DIRECT IMMEDIATE ANIMATIONS -------------------------------- */
  if ($('.im-animate.fade-in').length > 0) {
    gsap.fromTo('.im-animate.fade-in', {
      opacity: 0,
    },{
      opacity: 1,
      duration: 1,
      ease: 'power2.out'
    });
  }

  if($('.im-animate.stagger-fade').length > 0) {
    gsap.fromTo('.im-animate.stagger-fade', {
      opacity: 0
    },{
      opacity: 1,
      duration: 0.5,
      stagger: 0.2,
      ease: 'power2.out'
    });
  }


  /* DEFINE CSS SELECTORS --------------------------------------- */
  $('.st-animate.fade-in').each(function() {
    gsap.effects.fadeIn($(this));
  });

  $('.st-animate.slide-right').each(function() {
    gsap.effects.slideRight($(this));
  });

  $('.st-animate.slide-up').each(function() {
    gsap.effects.slideUp($(this));
  });


  /* DEFINE SPECIFIC BLOCKS AND SITUATIONS ---------------------- */

  // global basic content blocks
  $('.wp-block-singular').not('.accordion-container,.campaign-dual-column-text,.cols-image-text,.full-width-text,.image-cta-columns,.testimonial-block,.text-video-block').each(function() {
    $('> .wp-block-group__inner-container', this).each(function() {
      gsap.effects.fadeIn($(this));
      gsap.effects.slideUp($(this));
    });
  });
  
  // accordions
  $('.wp-block-singular.accordion-container').each(function() {
    gsap.effects.staggerFade('.wp-block-singular.accordion-container .accordion-item', { duration: 0.5, stagger: 0.2 });
  });
  
  // article items
  $('article.item').each(function() {
    gsap.effects.staggerFade('article.item');
  });
  
  // colored icon ctas
  $('.colored-icon-cta').each(function() {
    gsap.effects.staggerFade('.colored-icon-cta');
  });

  // custom columns
  $('.wp-element-singular.custom-columns').each(function() {
    gsap.effects.staggerFade('.wp-element-singular.custom-columns .wp-block-column');
  });

  // footer
  $('#footer').each(function() {
    gsap.effects.staggerFade('#footer > .wrap');
  });

  // full-width cta
  $('.wp-block-singular.full-width-cta').each(function() {
    gsap.effects.staggerFadeSlide('.cta-content .wp-block-group__inner-container > *', this);
  });

  // image cta columns
  $('.wp-block-singular.image-cta-columns').each(function() {
    gsap.effects.staggerFade('.wp-block-singular.image-cta-columns .wp-block-columns .wp-block-column');
  });  

  // image + text columns
  $('.wp-block-singular.cols-image-text').each(function() {
    gsap.effects.staggerFade('.wp-block-singular.cols-image-text .wp-block-columns .wp-block-column');
  });

  // post banners 
  $('#banner-post').each(function() {
    gsap.effects.staggerFadeSlide($('.content-wrap > *', this), { delay: 1 });
    gsap.effects.staggerFade('#banner-post .post-banner-section');
  });

  // quick links
  $('.wp-element-singular.quick-links').each(function() {
    gsap.effects.staggerFade('.wp-element-singular.quick-links .item', { stagger: 0.15 });
  });

  // search results
  $('#search-results').each(function() {
    gsap.effects.staggerFade('#search-results .search-result');
  });

  // stats columns
  $('.singular-stats-columns').each(function() {
    gsap.effects.staggerFade('.singular-stats-columns > .wp-block-column');
  });

  // team members grid
  $('.team-members-grid').each(function() {
    gsap.effects.staggerFade('.team-members-grid .team-member');
  });

  // testimonials block
  $('.wp-block-singular.testimonial-block').each(function() {
    gsap.effects.fadeIn($('.image', this));
    gsap.effects.slideUp($('.image', this), { duration: 0.75 });
    gsap.effects.staggerFade($('.content-item', this));
  });

  // text video block
  $('.wp-block-singular.text-video-block').each(function() {
    gsap.effects.staggerFade('.wp-block-singular.text-video-block .tvb-columns [class*="col-"]');
  });


  /* CAMPAIGNS -------------------------------------------------- */

  // banners
  $('.campaign-banner').each(function() {
    gsap.effects.staggerFade('.campaign-banner > .wrap > *');
  });

  // dual column text
  $('.campaign-dual-column-text').each(function() {
    gsap.effects.staggerFade('.campaign-dual-column-text .wp-block-columns .wp-block-column');
  });

  // grantees grid
  $('.campaign-grantees-grid').each(function() {
    gsap.effects.staggerFade('.campaign-grantees-grid > .wrap .grid-item');
  });

});
